import { render } from "./RemoveMenuItem.vue?vue&type=template&id=179b242c&scoped=true"
import script from "./RemoveMenuItem.vue?vue&type=script&lang=js"
export * from "./RemoveMenuItem.vue?vue&type=script&lang=js"

import "./RemoveMenuItem.vue?vue&type=style&index=0&id=179b242c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179b242c"]])

export default __exports__